import React, { useContext } from "react";

import { mdiAlert } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

import RelatedOffers from "./availabilities/RelatedOffers";
import RelatedSmartlists from "./availabilities/RelatedSmartlists";
import { SmartlistType } from "../../api/MediaAPI.types";
import ContentContext from "../../contexts/ContentContext";
import ContentSection from "../content/ContentSection";
import Tooltip from "../tooltip/Tooltip";

import type { JSX } from "react";

import type { GetMediaResponse, MediaUpdated } from "../../api/MediaAPI.types";

function TabContentAvailability(): JSX.Element {
  const { t } = useTranslation("editor-content");

  const { item, onItemUpdate } = useContext<{
    item: GetMediaResponse;
    onItemUpdate: (media: MediaUpdated) => void;
  }>(ContentContext);

  const handleUpdateOffersMedia = (offers: MediaUpdated["offers"]): void => {
    onItemUpdate({ ...item, offers });
  };

  const handleUpdateSmartlistsMedia = (
    smartlists: MediaUpdated["smartlists"],
  ): void => {
    onItemUpdate({ ...item, smartlists });
  };

  const hasMultipleOffersWithAds = item.has_multiple_ads;

  const titleOffers = hasMultipleOffersWithAds ? (
    <div className="flex items-center gap-[0.3125rem]">
      {t("offers")}
      <Icon
        className="text-destructive cursor-auto"
        data-tooltip-id="offers-multiple-ads-warning"
        path={mdiAlert}
        size={0.9375}
      />
      <Tooltip
        content={t("monetizationConflict")}
        id="offers-multiple-ads-warning"
      />
    </div>
  ) : (
    t("offers")
  );

  return (
    <React.Fragment>
      <ContentSection title={titleOffers}>
        <RelatedOffers
          offers={item.offers}
          onUpdateOffersMedia={handleUpdateOffersMedia}
        />
      </ContentSection>
      <ContentSection title={t("smartlistsTab")}>
        <RelatedSmartlists
          mediaChildren={item.children}
          mediaType={item.type}
          onUpdateSmartlistsMedia={handleUpdateSmartlistsMedia}
          path="smartlist"
          smartlists={item.smartlists}
          smartlistTypes={[SmartlistType.AUDIO, SmartlistType.STANDARD]}
        />
      </ContentSection>
      <ContentSection title={t("collections")}>
        <RelatedSmartlists
          mediaChildren={item.children}
          mediaType={item.type}
          onUpdateSmartlistsMedia={handleUpdateSmartlistsMedia}
          path="collections"
          smartlists={item.smartlists}
          smartlistTypes={[SmartlistType.COLLECTION]}
        />
      </ContentSection>
      <ContentSection title={t("series")}>
        <RelatedSmartlists
          isReadOnly
          mediaChildren={item.children}
          mediaType={item.type}
          path="series"
          smartlists={item.smartlists}
          smartlistTypes={[SmartlistType.SEASON]}
        />
      </ContentSection>
    </React.Fragment>
  );
}

export default TabContentAvailability;
